import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import colors from '../../../constants/colors';
import { PaymentAmountType } from '../../../constants/enums';
import { usePaymentsContext } from '../../../store/payments';
import PaymentShoppingCart from './PaymentShoppingCart';

const SelectedPaymentsPage = () => {
  const { state: paymentState } = usePaymentsContext();
  const navigate = useNavigate();
  const validPayments = Object.keys(paymentState.selectedPayments).filter(
    (policyNumber) =>
      paymentState.selectedPayments[policyNumber]?.paymentType !==
        PaymentAmountType.NO_PAYMENT &&
      paymentState.selectedPayments[policyNumber]?.amount &&
      parseFloat(paymentState.selectedPayments[policyNumber]?.amount ?? '') > 0
  );

  useEffect(() => {
    if (validPayments.length === 0) {
      navigate('/multiple-payment');
    }
  }, [validPayments]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Stack
      direction="column"
      sx={{
        p: { mobile: 2, tablet: 4 },
        pt: { mobile: 3 },
        width: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: {
            mobile: 33,
            tablet: 44,
          },
          lineHeight: {
            mobile: '32px',
            tablet: '32px',
            desktop: '56px',
          },
          letterSpacing: {
            mobile: 0.4,
            tablet: 0.4,
            desktop: 0.6,
          },
          fontWeight: {
            mobile: 400,
            tablet: 500,
          },
          color: colors.csaaBlack,
          mb: { mobile: 2, tablet: 3 },
        }}
      >
        Pay multiple policies
      </Typography>
      <PaymentShoppingCart />
    </Stack>
  );
};

export default SelectedPaymentsPage;
